export default "__VITE_ASSET__nh$b0$LE__"